import * as amplitude from '@amplitude/analytics-browser'
import { injectable } from 'inversify'

import { IGenericMetricsProvider, PropertyObject } from './IGenericMetricsProvider'

@injectable()
export class AmplitudeMetricsProvider implements IGenericMetricsProvider {
  identify: amplitude.Identify = new amplitude.Identify()

  constructor() {
    amplitude.init(import.meta.env.VITE_AMPLITUDE_KEY, undefined, {
      minIdLength: 1,
      // O SDK tem o próprio enum (None=0 … Debug=4), que colide com o nosso LogLevel (Debug=0): passar o
      // nosso desligava o log do SDK em todos os ambientes. Mesma regra do logger da casa em main.tsx.
      logLevel: import.meta.env.MODE === 'production' ? amplitude.Types.LogLevel.Warn : amplitude.Types.LogLevel.Debug
    })
  }

  sendMetric(key: string, extra: PropertyObject) {
    amplitude.track(key, { ...extra, source: 'planning', platform: 'Web' })
  }

  setUserId(userId: string | number) {
    if (!userId) {
      amplitude.reset()
    } else {
      amplitude.setUserId(String(userId))
    }
  }

  setUserProperties(properties: { [key: string]: any }) {
    if (!properties) return

    for (const key in properties) {
      this.identify.set(key, properties[key])
    }

    amplitude.identify(this.identify)
  }
}
